import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const answers = [{
  q: 'How much does ducted aircon cost in Perth?',
  a: 'Ducted reverse cycle installation in Perth typically ranges A$10,000 to A$20,000 fully installed, depending on home size, zoning and brand. Langler Air quotes fixed price on site.',
  src: 'Verified pricing, Langler Air'
}, {
  q: 'Which AC brand is best for Perth?',
  a: 'Mitsubishi Electric, Daikin and Rinnai are the three most reliable brands for Perth conditions. Langler Air is a Mitsubishi Electric Diamond Dealer and installs all three.',
  src: 'Mike Spear, 30+ years installing'
}, {
  q: 'How long does installation take?',
  a: 'A single split system is usually installed in one day. Ducted reverse cycle installations take two to three days depending on home size and zoning complexity.',
  src: 'Langler Air install records'
}, {
  q: 'Do you service my Perth suburb?',
  a: 'Langler Air installs across all Perth metropolitan suburbs and regional WA, working from our Balcatta workshop at Unit 2/3 Cressall Rd, WA 6021.',
  src: 'Verified service area'
}, {
  q: 'What is reverse cycle air conditioning?',
  a: 'Reverse cycle uses one system to heat and cool. It is the most cost effective way to heat a Perth home, working efficiently down to about five degrees outside.',
  src: 'Industry standard'
}, {
  q: 'Do you offer a warranty?',
  a: 'Every Langler Air installation carries a workmanship guarantee plus the full manufacturer warranty on all major brand units we install.',
  src: 'Langler Air policy'
}, {
  q: 'What size air conditioner do I need?',
  a: 'Sizing depends on room dimensions, ceiling height, insulation and orientation. Mike sizes every system on site at the free quote; no online calculator replaces a proper site visit.',
  src: 'Mike Spear, licensed installer'
}, {
  q: 'Can I get finance for an air conditioner?',
  a: 'Yes. Langler Air offers finance options through accredited providers. Ask Mike at your free quote for current terms.',
  src: 'Langler Air policy'
}];
export function AEOAnswerHub() {
  return <section id="answers" aria-labelledby="aeo-heading" className="bg-white py-20 md:py-28 scroll-mt-24" data-id="element-26">
      <div className="max-w-6xl mx-auto px-6" data-id="element-27">
        <div className="max-w-3xl mb-12" data-id="element-28">
          <div className="kicker mb-3" data-id="element-29">Ask Mike</div>
          <h2 id="aeo-heading" className="text-3xl md:text-5xl font-bold text-ink-900 tracking-tight leading-tight" data-id="element-30">
            Air conditioning in Perth, answered.
          </h2>
          <p className="mt-4 text-lg text-stone-600 max-w-2xl" data-id="element-31">
            Straight answers to the questions Perth homeowners ask most.
            Verified by Mike Spear, installing since 1995.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-32">
          {answers.map((item, i) => <motion.article key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.45,
          delay: i * 0.04
        }} className="lift-card bg-white rounded-2xl p-7 border border-stone-200 flex flex-col" itemScope itemType="https://schema.org/Question" data-id="element-33">
              <h3 itemProp="name" className="text-lg font-semibold text-ink-900 leading-snug mb-3 tracking-tight" data-id="element-34">
                {item.q}
              </h3>
              <div itemProp="acceptedAnswer" itemScope itemType="https://schema.org/Answer" className="flex-grow" data-id="element-35">
                <p itemProp="text" className="aeo-answer text-base text-stone-700 leading-relaxed" data-id="element-36">
                  {item.a}
                </p>
              </div>
              <div className="mt-5 pt-4 border-t border-stone-100 flex items-center gap-2 text-xs text-stone-500" data-id="element-37">
                <CheckCircle2 size={13} className="text-success flex-shrink-0" data-id="element-38" />
                <span className="font-medium" data-id="element-39">{item.src}</span>
              </div>
            </motion.article>)}
        </div>

        <div className="mt-10 text-center" data-id="element-40">
          <a href="#quote-form" className="inline-flex items-center gap-2 text-brand font-semibold hover:underline" data-id="element-41">
            Have a different question? Ask Mike directly →
          </a>
        </div>
      </div>
    </section>;
}